import type { Brand, BrandName } from "./types";

export async function getBrand(brand: BrandName): Promise<Brand> {
  if (brand === "switchboard") {
    const switchboard = await import("../switchboard");
    return switchboard.brand;
  }

  if (brand === "metaplex") {
    const metaplex = await import("../metaplex");
    return metaplex.brand;
  }

  const evangelist = await import("../evangelist");
  return evangelist.brand;
}
